// extracted by mini-css-extract-plugin
export default {"Emoji":"Emoji_Emoji__l7yig","Twemoji":"Emoji_Twemoji__xKvRQ","NotoColorEmoji":"Emoji_NotoColorEmoji__ec7Kr"};